import locales from "./locales/locales";
import router from './routes/routes'

export const SpecialtiesModule = {
	name: 'specialties',
	routes: router,
	locales: locales,
}